import { Flex, Spin } from "@gravity-ui/uikit";
import { useAtom, useAction } from "@reatom/npm-react";
import { InfinityScroll } from "src/components";

import { OrderListComponent } from "../../components/OrderListComponent/OrderListComponent";
import { orderListAtom, hasMoreAtom } from "../../store/atoms/orderList";
import { ordersViewAtom } from "../../store/atoms/orderListView";
import { loadMoreOrderList } from "../../store/fetchers/getPoizonBuyerOrderList";
import css from "./OrderListWithInfiniteScroll.module.scss";
export const OrderListWithInfiniteScroll = () => {
  const [orderList] = useAtom(orderListAtom);
  const loadMore = useAction(loadMoreOrderList);
  const [isLoading] = useAtom(loadMoreOrderList.isLoadingAtom);
  const [hasMore] = useAtom(hasMoreAtom);
  const [ordersViewValue] = useAtom(ordersViewAtom);
  return (
    <InfinityScroll loadMore={loadMore} disabled={!hasMore}>
      <OrderListComponent
        responseData={orderList}
        isLoading={isLoading}
        ordersViewValue={ordersViewValue}
      />
      <div className={css.spinDiv}>
        {isLoading && (
          <Flex className={css.spin}>
            <Spin size="l" />
          </Flex>
        )}
      </div>
    </InfinityScroll>
  );
};
